const digest = 'c150655cd4900b4d9eb7567b49d3b9ee5006987364b614cc7707f9a935430478';
const css = `._link_cf99r_1 a{display:inline;min-height:0}._badge_cf99r_6{left:.5rem;position:absolute;top:.5rem;z-index:1}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'link': '_link_cf99r_1', 'badge': '_badge_cf99r_6' };
export const link = '_link_cf99r_1';
export const badge = '_badge_cf99r_6';
export { css, digest };